// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f4fb2615","453":"d7e3d8c7"}[chunkId] + ".chunk.js";
};